// extracted by mini-css-extract-plugin
export default {"container":"country-code_container__Ucls1","code":"country-code_code__zWeFm","active":"country-code_active__a3Vx9"};